import { render, staticRenderFns } from "./OperationDialog.vue?vue&type=template&id=36be2dd0&scoped=true"
import script from "./OperationDialog.vue?vue&type=script&lang=js"
export * from "./OperationDialog.vue?vue&type=script&lang=js"
import style0 from "./OperationDialog.vue?vue&type=style&index=0&id=36be2dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36be2dd0",
  null
  
)

export default component.exports